// API Configuration
const getEnvVar = (key, defaultValue) => {
  // Check for runtime config (Docker injection)
  if (window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  // Check for build-time environment variables
  if (process.env[key]) {
    return process.env[key];
  }
  return defaultValue;
};

export const API_BASE_URL = getEnvVar('REACT_APP_API_BASE_URL', 'http://localhost:8080');

// API Functions
export async function fetchWebsiteStats() {
  const url = `${API_BASE_URL}/website/stats`;
  
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    console.error(`API Error [/website/stats]:`, error);
    return { data: null, error: error.message };
  }
}

export async function fetchStaffMembers() {
  const url = `${API_BASE_URL}/website/staff`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    console.error(`API Error [/website/staff]:`, error);
    return { data: null, error: error.message };
  }
}

export async function fetchStorePackages() {
  const url = `${API_BASE_URL}/website/store/packages`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    console.error(`API Error [/website/store/packages]:`, error);
    return { data: null, error: error.message };
  }
}

export async function createTebexBasket(basketData) {
  const url = `${API_BASE_URL}/website/store/create-basket`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(basketData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    console.error(`API Error [/website/store/create-basket]:`, error);
    return { data: null, error: error.message };
  }
}

export async function fetchNewsArticles() {
  const url = `${API_BASE_URL}/website/news`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    console.error(`API Error [/website/news]:`, error);
    return { data: null, error: error.message };
  }
}

export async function fetchNewsArticleBySlug(slug) {
  const url = `${API_BASE_URL}/website/news/${slug}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    console.error(`API Error [/website/news/${slug}]:`, error);
    return { data: null, error: error.message };
  }
}